export default {
  "content": "<g fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M12.586 1.698c-.46-.408.188-1.112.639-.685L15.41 3.05c.164.17.164.39 0 .554l-2.158 2.332c-.418.46-1.107-.193-.685-.638l1.356-1.474c-3.247.099-5.87 2.567-5.87 5.588 0 .258-.206.47-.469.47a.468.468 0 01-.469-.47c0-3.519 3.003-6.404 6.742-6.526l-1.272-1.187z\"/><path d=\"M1.5 3.434a.5.5 0 00-.5.5v9.685a.5.5 0 00.5.5h13a.5.5 0 00.5-.5V7.66a.5.5 0 111 0v5.96a1.5 1.5 0 01-1.5 1.5h-13a1.5 1.5 0 01-1.5-1.5V3.934a1.5 1.5 0 011.5-1.5h4.488a.5.5 0 110 1H1.5z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};